import { CategoryNamespace } from '@onereach/billing-shared';

export const EVENT_TYPE_MAP = {
  [CategoryNamespace.PROCESSING_FLOW]: 'Processing Flow',
  [CategoryNamespace.PROCESSING_VOICE]: 'Processing Voice',
  [CategoryNamespace.EXECUTABLE_GENERAL]: 'Executable',
  [CategoryNamespace.EXECUTABLE_LLM]: 'Executable LLM',
  [CategoryNamespace.LOOKUP]: 'Lookup',
  [CategoryNamespace.TELEPHONY_VOICE]: 'Telephony',
  [CategoryNamespace.MESSAGING_TEXT]: 'Messaging',
  [CategoryNamespace.CONVERSATIONS_WAP]: 'Conversations',
  [CategoryNamespace.CARRIER_FEE]: 'Carrier Fee',
  [CategoryNamespace.USER]: 'Users',
  [CategoryNamespace.IDENTIFIER]: 'Identifiers',
  [CategoryNamespace.EXECUTABLE_PORT_IN_IDENTIFIER]: 'Port-In Identifiers',
  [CategoryNamespace.STORAGE_GENERAL]: 'Storage',
  [CategoryNamespace.STORAGE_WEAVIATE]: 'Weaviate Storage',
  [CategoryNamespace.PRODUCT]: 'Product',
};
